import { useSelector } from "react-redux"

import TitleSection from "../../../BusinessSettings/components/TitleSection"

// The "Receipt for <merchant>" heading above every Receipt screen support opens
// from Business settings. The account is the one BusinessSettings already loaded
// for the page (`?business_account_id=...`), so this needs no fetch of its own.
//
// Renders nothing on a merchant's own copy of those pages, which is why callers
// drop it in unconditionally rather than repeating the check at each site.
export const AdminReceiptTitle = ({ usersViewForAdmin }) => {
  const businessAccount = useSelector((s) => s.user?.businessAccount)

  if (!usersViewForAdmin) return null

  return (
    <TitleSection
      title={`Receipt for ${businessAccount?.name || ""}`}
      link={businessAccount?.url}
    />
  )
}

export default AdminReceiptTitle
